import { useCallback, useRef } from 'react';
import { useScheduler } from './eventScheduler';
/**
 * Use as a player emulator for demo or replay recorded hits.
 */
export function useReplayBot(timing, clock, clockState, evaluator, hitScheduler) {
    const cursor = useRef(0);
    const reset = useCallback(() => {
        cursor.current = 0;
    }, []);
    const seek = useCallback((timestamp) => {
        cursor.current = Math.max(0, evaluator.hits.findIndex(hit => hit.timestamp > timestamp));
    }, [evaluator]);
    useScheduler(timing, clock, clockState, evaluator.hits, hitScheduler, reset, seek, cursor);
}
//# sourceMappingURL=replayBot.js.map